/**
 * Time-of-day greeting for the admin home page. Uses the browser's
 * local hour — fine for a friendly greeting, not worth pulling
 * timezone from the user's profile.
 *
 * Bands:
 *   05:00 – 11:59  Good morning
 *   12:00 – 17:59  Good afternoon
 *   18:00 – 21:59  Good evening
 *   22:00 – 04:59  Working late
 */
export const getTimeOfDayGreeting = (date: Date = new Date()): string => {
	const hour = date.getHours();
	if (hour >= 5 && hour < 12) return "Good morning";
	if (hour >= 12 && hour < 18) return "Good afternoon";
	if (hour >= 18 && hour < 22) return "Good evening";
	// Default branch covers 22:00 – 04:59 (late night through pre-dawn).
	return "Working late";
};
